import List from './actions/list';
import Find from './actions/find';
import Create from './actions/create';
import Update from './actions/update';
import Delete from './actions/delete';
import Resource from './resource';

export default class ChoiceList extends Resource {
  get resourceName() {
    return 'choice_list';
  }

  get resourcesName() {
    return 'choice_lists';
  }
}

// @ts-ignore
List.includeInto(ChoiceList);
// @ts-ignore
Find.includeInto(ChoiceList);
// @ts-ignore
Create.includeInto(ChoiceList);
// @ts-ignore
Update.includeInto(ChoiceList);
// @ts-ignore
Delete.includeInto(ChoiceList);
